import WidgetHeaderWide, { Props } from './WidgetHeaderWide';

export default WidgetHeaderWide;
export type Props = Props;
